import { render } from "./SectionEmployeeProfile.vue?vue&type=template&id=2876b0da&scoped=true"
import script from "./SectionEmployeeProfile.vue?vue&type=script&lang=js"
export * from "./SectionEmployeeProfile.vue?vue&type=script&lang=js"

import "./SectionEmployeeProfile.vue?vue&type=style&index=0&id=2876b0da&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2876b0da"]])

export default __exports__